import type { ReactNode } from "react";
import { NovaraLogo } from "./NovaraLogo.js";

// Sticky black brand bar with the white Novara logo, the app title, and the Novara Glow strip
// under it: the same header as it-assets and sites.novara.com. children are the app's buttons;
// account is the signed-in user menu at the far right.
export function SiteHeader({ title, children, account }: { title: string; children?: ReactNode; account?: ReactNode }) {
  return (
    <header className="sitehead">
      <div className="brandbar">
        <div className="brandbar-in">
          <NovaraLogo />
          <h1>{title}</h1>
          {children ? <nav aria-label="Main">{children}</nav> : null}
          {account}
        </div>
      </div>
      <div className="glow" aria-hidden="true" />
    </header>
  );
}
